import { z } from 'zod';
import { PackageSummary } from '@pages/Electrify2515/PackageSummary';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/connect/_authenticated/electrify2515/payment')({
  component: PackageSummary,
  validateSearch: z.object({
    trackingId: z.string(),
  }),
});
